import { createAction, RSAAAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import ActionTypes from './actionTypes'

interface PresignedURLPayload {
    url: string;
}

type GetChunkURLRequest = {
    type: typeof ActionTypes.GET_CHUNK_URL_REQUEST;
    payload: never;
}

type GetChunkURLSuccess = {
    type: typeof ActionTypes.GET_CHUNK_URL_SUCCESS;
    payload: PresignedURLPayload;
}

type GetChunkURLFailure = {
    type: typeof ActionTypes.GET_CHUNK_URL_FAILURE;
    payload: Error;
}

export type GetChunkURLAction = GetChunkURLRequest
    | GetChunkURLSuccess
    | GetChunkURLFailure

export type GetChunkURLRSAAAction = RSAAAction<
    RootState,
    PresignedURLPayload | Error,
    never
> 

interface GetChunkUploadURLParams {
    filename: string;
    partNumber: number;
    uploadId: string;
}

/**
 * Get presigned URL for uploading a file chunk
 * @param upload
 * @param upload.filename
 * @param upload.partNumber
 * @param upload.uploadId
 * @param opts
 * @param opts.basePath
 */
function getChunkUploadUrl(
    { filename, partNumber, uploadId }: GetChunkUploadURLParams,
    opts?: { basePath?: string },
): GetChunkURLRSAAAction {
    const { basePath = HUBBLE_API_TOKEN } = opts ?? {}

    return createAction<RootState, PresignedURLPayload | Error, never>({
        endpoint: `${basePath}/upload/${uploadId}`,
        method: 'PUT',
        body: JSON.stringify({
            filename,
            partNumber,
        }),
        types: [
            ActionTypes.GET_CHUNK_URL_REQUEST,
            ActionTypes.GET_CHUNK_URL_SUCCESS,
            ActionTypes.GET_CHUNK_URL_FAILURE,
        ],
    }) 
}

export default getChunkUploadUrl
